
import { ActionIcon, Badge, Button, Grid, Modal, Tooltip, Text, createStyles, Group, Indicator} from '@mantine/core';
import { AlertCircle, ArrowUpCircle,DiscountCheck } from 'tabler-icons-react';
import intl from "react-intl-universal";
import { useSelector,useDispatch } from 'react-redux';
import { set_docstoconvert } from '../../slice/mainslice';
import { useEffect, useState } from 'react';

const useStyles = createStyles((theme) => ({
  noUC: {
    textTransform: `none`,
    cursor: `pointer`,
  },
  noUC_: {
    textTransform: `none`,
  },
  margintop: {
    marginTop: `5px`,
  },
}));

const PdfLabel = (props:any) => {
  const { classes } = useStyles();
  const dispatch = useDispatch()
  const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
  const [opened, setOpened] = useState(false);
  const [forceconsvert, setforceconsvert] = useState(false);

  const [datasignstatus, setdataSignStatus] = useState<any[]>([]);
   const initdocs = useSelector((state: any) => state.user.meetingdocs)
   


   let removeButton
   let tooltipmessage = intl.get('PDF_LABLE_TT_KONVERT')

     useEffect(() => {
      const datatosignstatus = initdocs?.filter((obj: { resourceId: any }) => obj.resourceId === props.resourceId) || [];
      if (datatosignstatus[0]){
       setdataSignStatus(datatosignstatus[0].signatures || [])
      }
     }, [props]);

    


   // PDFs nur Badget für Setu

   if (datasignstatus.length === 0) {
   removeButton = (
    <ActionIcon size="xs" color="dark" radius="xl" variant="outline">
      <ArrowUpCircle size={14} />
    </ActionIcon>
    );
   } else if (datasignstatus.length >= 1) {
    removeButton = (
      <ActionIcon size="xs" color="dark" radius="xl" variant="outline">
        <AlertCircle size={14} />
      </ActionIcon>
      );
    tooltipmessage = intl.get('PDF_LABLE_TT_KONVERT_WARNING')
    }

    const openModal = () => {
      setOpened(true);
      setforceconsvert(true)
    };

    const handleCloseSigninfo = () => {
      setOpened(false);
      setforceconsvert(false)
    };
  
    const confirmforcekonvert = () => {
      convertsinglepdf()
      setforceconsvert(false)
      setOpened(false);
    }
 
  const convertsinglepdf = () => {
   
    const storeArray = [{
      resourceId: props.resourceId,
      error: null
    }];


    const convertarray = {
      drnId: meetinginfo.drnId,
      DocumentResourceIds: [props.resourceId],
      IsForced: forceconsvert
    };


    //console.log(storeArray)
    //console.log(convertarray)

     dispatch(set_docstoconvert(storeArray))
     dispatch({ type: 'SIGNALR_REQUEST_CONVERTDOKS', payload: convertarray });

  }

  return (
  <>
  {/* PDFs nur Badget für Setup */}
  {!props.convert &&
    <>
    {!props.isPDFA1b &&
      <Tooltip label={tooltipmessage} >
          <Badge color="gray" variant="filled" className={classes.noUC} size="sm" radius="sm" >{intl.get('PDF_LABLE_PDF')} </Badge>
      </Tooltip>
      }
      {props.isPDFA1b &&
      
        <Tooltip label={intl.get('PDF_LABLE_TT_INFO')} >
            <Badge color="dark" variant="filled" size="sm" radius="sm" className={classes.noUC} >{intl.get('PDF_LABLE_PDFA')} </Badge>
        </Tooltip>
        
      
      }
      </>
  }
  {/* PDFs Single Konvertieung */}
  {props.convert &&
      <>
      {!props.isPDFA1b && datasignstatus.length === 0 &&
      <Group >
        <Tooltip label={intl.get('PDF_LABLE_TT_INFO_KONVERT')} >
            <Badge color="gray" variant="filled" className={classes.noUC} size="sm" radius="sm" rightSection={removeButton} onClick={() => convertsinglepdf()}>{intl.get('PDF_LABLE_PDF')} </Badge>
        </Tooltip>
        
      </Group>
      }
      {!props.isPDFA1b && datasignstatus.length >= 1 && 
      <Group >
        <Tooltip label={intl.get('PDF_LABLE_TT_INFO_KONVERT_WARNING')} >
            <Badge color="gray" variant="filled" size="sm" className={classes.noUC} radius="sm"  onClick={() => openModal()}>{intl.get('PDF_LABLE_PDF')}  </Badge>
        </Tooltip>
        {props.viewcount &&
        <Indicator  
           label={datasignstatus.length}
           size={14} 
           offset={3}  
           styles={(theme) => ({
            indicator: {
              fontSize: '6px',
            },
          })}
          >
           <div className={classes.margintop}><DiscountCheck size={18} /></div>
        </Indicator>
        }
      </Group>
      }


      {props.isPDFA1b && datasignstatus.length === 0 &&
        <Group >
        <Tooltip label={intl.get('PDF_LABLE_TT_INFO')} >
            <Badge className={classes.noUC_}  color="dark" variant="filled" size="sm" radius="sm">{intl.get('PDF_LABLE_PDFA')}</Badge>
        </Tooltip>
        </Group>
        }
        
        
        {props.isPDFA1b && datasignstatus.length >= 1 && 
        <Group >
        <Tooltip label={intl.get('PDF_LABLE_TT_INFO')} >
            <Badge className={classes.noUC_}  color="dark" variant="filled" size="sm" radius="sm">{intl.get('PDF_LABLE_PDFA')}</Badge>
        </Tooltip>
        {props.viewcount &&
        <Indicator  
           label={datasignstatus.length}
           size={14} 
           offset={3}  
           styles={(theme) => ({
            indicator: {
              fontSize: '6px',
            },
          })}
          >
           <div className={classes.margintop}><DiscountCheck size={18} /></div>
        </Indicator>
        }
        </Group>
        }
        </>
    }

<Modal
        title=""
        opened={opened}
        onClose={handleCloseSigninfo}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="auto"
        shadow="sm"
        centered
        >
          <Text>{intl.get('SETUP_MEETING_MODAL_DOCHAVESIGNS')}</Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={confirmforcekonvert}>{intl.get('SETUP_MEETING_MODAL_DOCHAVESIGNS_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" onClick={handleCloseSigninfo} variant="light">{intl.get('SETUP_MEETING_MODAL_DOCHAVESIGNS_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 
  </>
  );
}


export default PdfLabel;

